import {
	containerHighlight,
	containerHighlightDark,
	dragOverHighlight,
	threadHistoryToggleButton,
} from "@/common/style/commonStyle";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		borderRadius: tokens.borderRadiusMedium,
		backgroundColor: tokens.colorNeutralBackground1,
	},
	rootHighlighted: {
		borderRadius: tokens.borderRadiusMedium,
		backgroundColor: tokens.colorNeutralBackground1,
		...containerHighlight(),
	},
	rootHighlightedDark: {
		borderRadius: tokens.borderRadiusMedium,
		backgroundColor: tokens.colorNeutralBackground1,
		...containerHighlightDark(),
	},
	attachmentsContainer: {
		padding: `${tokens.spacingHorizontalM} ${tokens.spacingHorizontalL}`,
	},
	subjectContainer: {
		paddingRight: "8px",
	},
	subjectInfo: {
		padding: `0 ${tokens.spacingHorizontalL} ${tokens.spacingVerticalS}`,
		color: tokens.colorNeutralForeground3,
	},
	subjectInfoIcon: {
		flexShrink: 0,
		color: tokens.colorBrandForeground1,
	},
	subjectInput: {
		padding: tokens.spacingHorizontalL,
		border: 0,
		fontSize: tokens.fontSizeBase200,

		"&:active, &:hover, &:focus, &:visited, &:focus-within, &:focus-visible, &:target":
			{
				outline: 0,
			},
		"&:disabled": {
			backgroundColor: tokens.colorNeutralBackground1,
		},
		flexGrow: 1,
	},
	sendButton: {
		">button": {
			minWidth: "0px",
		},
	},
	bottomContainer: {
		padding: tokens.spacingHorizontalL,
	},
	pushToRight: {
		marginLeft: "auto",
	},
	discardButton: {
		backgroundColor: tokens.colorNeutralBackground3,
		color: tokens.colorNeutralForeground2,
		"&:hover": {
			backgroundColor: tokens.colorNeutralBackground3Hover,
			color: tokens.colorNeutralForeground2Hover,
		},
		"&:active": {
			backgroundColor: tokens.colorNeutralBackground3Pressed,
		},
	},
	multiselectRoot: {
		padding: `0 ${tokens.spacingHorizontalS}`,
	},
	recipientsLabel: {
		width: "36px",
	},
	multiInputElement: {
		width: "auto",
		flexGrow: 1,
		minWidth: "140px",
		"&:focus-within": {
			outline: "none",
			boxShadow: "none",
		},
	},
	dismissibleRecipientField: {
		flexGrow: 1,
		minWidth: 0,
	},
	recipientDismissButton: {
		flexShrink: 0,
		marginRight: tokens.spacingHorizontalS,
	},
	readOnlyRecipientContainer: {
		height: "46px",
		paddingLeft: "16px",
		paddingRight: "6px",
	},
	draggedOverContainer: {
		...dragOverHighlight(),
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	threadHistoryContainer: {
		padding: "12px",
	},
	threadHistoryToggleButton: {
		...threadHistoryToggleButton(),
	},
	aiIndicatorContainer: {
		padding: `4px ${tokens.spacingHorizontalL}`,
	},
});
